export const deviceOsType = {
  ios: 'ios',
  android: 'android',
};
